<template>
  <div class="container">
    <div class="home-banner">
      <img class="banner-bg" src="@/assets/qiye-banner.png" alt="">
      <div class="textBox typeArea">
        <p class="centerBanner animated zoomIn">企业数字化转型</p>
        <p class="title_secound animated centerBanner  zoomIn" style="font-size: 24px;">企业是经济运行的细胞体，是数字化转型的主要承担者</p>
      </div>
    </div>
    <div class="zhengfu">
      <div class="zf-box">
        <div class="zf-cont">
          <div style="padding-bottom: 80px;"></div>
          <div class="common-title">
            概述 
          </div>
          <div class="zf-text">
            <p>企业级数字化转型针对的是十分具体的业务需要，目的是识别机会、规避风险和提高效率。使用企业运行数据进行业务诊断并提供决策指向，在越来越多的行业和企业中正在成为刚性的需求。 </p>
            <p>对于绝大多数情形，企业对业务痛点有明确的认知，但对如何使用业务数据解决痛点问题，仍处在答案搜素的阶段。  </p>
          </div>
        </div>
      </div>
      <div class="hy">
        <div class="hy-box">
          <div class="hy-cont">
            <div style="padding-bottom: 80px;"></div>
            <div class="common-title">
              应用场景 
            </div>
            <div class="hy-list">
              <ul>
                
                <li>
                  <a @click="goView('xiangmu')">
                  <div class="hy-list-img">
                    <img src="@/assets/q-1.png" alt="">
                  </div>
                  <div class="hy-list-text">
                    对项目与人员的全面数字化管理
                  </div>
                  <div class="hy-list-info animatedpull pullBox">
                      <div class="hy-info-title">
                        对项目与人员的全面数字化管理
                      </div>
                      <div class="hy-info-text">
                        对例如从事地理测绘等的项目型公司，要在不同的地域同时开展不同类型、规模和承包形式的项目，涉及繁杂的流程管理以及对人财物的调度。为此，数字化管理与决策是保证全面把握各类业绩指标实现状况的关键性措施。
                      </div>
                    </div>
                  </a>
                </li>
                
                <li>
                  <a @click="goView('zhaopin')">
                  <div class="hy-list-img">
                    <img src="@/assets/q-2.png" alt="">
                  </div>
                  <div class="hy-list-text">
                    代工企业对大量一线工人进行数字化招聘和排岗优化
                  </div>
                  <div class="hy-list-info animatedpull pullBox">
                      <div class="hy-info-title">
                        代工企业对大量一线工人进行数字化招聘和排岗优化
                      </div>
                      <div class="hy-info-text">
                        某上市代工厂，一线车间工人的雇工数量从2020年六月起有了快速的增长；这一快速增长伴随着工厂对雇工来源所做的调整，即从原来以自主招工为主，转为主要使用劳务公司来输送。工人的离岗率出现了成倍的增加，为保有一万人的一线工人人数，每年需招收4万工人。
                      </div>
                    </div>
                  </a>
                </li>
                
                <li>
                  <a @click="goView('kaoshi')">
                  <div class="hy-list-img">
                    <img src="@/assets/q-3.png" alt="">
                  </div>
                  <div class="hy-list-text">
                    基于考试大数据的综合测评报告生成系统
                  </div>
                  <div class="hy-list-info animatedpull pullBox">
                      <div class="hy-info-title">
                        基于考试大数据的综合测评报告生成系统
                      </div>
                      <div class="hy-info-text">
                        业内排头的职业资质考试平台公司，为国内外数百委托机构提供全国性的考试服务。业务中需要针对考试、考生和试题为委托机构生成测评分析报告。
                      </div>
                    </div>
                  </a>
                </li>
                
                <li>
                  <a @click="goView('dianxin')">
                  <div class="hy-list-img">
                    <img src="@/assets/q-4.png" alt="">
                  </div>
                  <div class="hy-list-text">
                    电信服务商客户满意度管理
                  </div>
                  <div class="hy-list-info animatedpull pullBox">
                      <div class="hy-info-title">
                        电信服务商客户满意度管理
                      </div>
                      <div class="hy-info-text">
                        电信服务行业的竞争势态已从扩展新增客户转为对存量客户的争夺，因而客户满意度成为主要的业绩指标。如何通过大数据把握客户满意度，正日益成为刚性需求。
                      </div>
                    </div>
                  </a>
                </li>
                <div style="clear: both;"></div>
              </ul>
            </div>
            <div style="padding-bottom: 20px;"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "enterprise",
  data() {
    return {
    };
  },
  methods: {
      
  },
  mounted() {
    $('.hy-list ul li').mouseenter( function(){
      $(this).find('.hy-list-info').css("display","block");
      $(this).find('.hy-list-info').addClass("animatedpull");
      $(this).find('.hy-list-info').addClass("pullBox");
    }).mouseleave( function(){
      $(this).find('.hy-list-info').css("display","none");
      $(this).find('.hy-list-info').removeClass("animatedpull");
      $(this).find('.hy-list-info').removeClass("pullBox");
    });
  },
}
</script>

<style scoped>
   
</style>